export enum HighlightableStringExpandableContainerState {
  Collapsed,
  ExpandedManually,
  ExpandedForHighlighting,
}

export function isExpandedState(state: HighlightableStringExpandableContainerState) {
  return state !== HighlightableStringExpandableContainerState.Collapsed;
}

export interface HighlightableStringExpandableContainer {
  shouldExpandForHighlighting: boolean;
  expandingState: HighlightableStringExpandableContainerState;
}

export function isHighlightableStringExpandableContainer(a: any) {
  return typeof a.shouldExpandForHighlighting === 'boolean' && typeof a.expandingState === 'number';
}

export function toggleExpandingStateManually(
  state: HighlightableStringExpandableContainerState,
): HighlightableStringExpandableContainerState {
  if (state === HighlightableStringExpandableContainerState.Collapsed) {
    return HighlightableStringExpandableContainerState.ExpandedManually;
  }
  return HighlightableStringExpandableContainerState.Collapsed;
}
